module.exports = __webpack_public_path__ + "static/media/utp-billing-card.a54b5e81.png";